import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

type Params = {
	id: string;
	response: boolean;
	googleMeetLink?: string;
	message?: string;
};

export const respondToMeetingRequest = makeSubmitData<Params>(
	"meetingRequestResponse"
);
